'use strict';

var _ = require('lodash');
var ReviewSponsorFlightPanelController = function ReviewSponsorFlightPanelController($scope, dataRetrieverService, constants) {
  $scope.showAddAnotherSponsorBtn = false;
  function needAnotherSponsorBtn(market) {
    var uniqueBusinessIds = [];
    if ($scope.leg && $scope.leg.origin && $scope.leg.destination) {
      dataRetrieverService.getDataRetriever(constants.SCHEDULE_CHANGE_SCREEN, constants.SPONSOR_FORECAST_FLIGHT_MODE).retrieveSimpleData(constants.SPONSOR_FORECAST_FLIGHT_MODE, undefined, [market.origin, market.destination]).then(function (res) {
        _.forEach(res, function (legSchedules) {
          _.forEach(legSchedules.legSchedules, function (legSchedule) {
            if (uniqueBusinessIds.indexOf(legSchedule.legBusinessId) === -1) {
              uniqueBusinessIds.push(legSchedule.legBusinessId);
            }
          });
        });
        var assignedIds = _.chain($scope.scheduleChange.managedEntities).filter(['leg', $scope.leg.leg]).map('flightSponsor.sourceBusinessId').value();
        if (uniqueBusinessIds.length !== assignedIds.length) {
          $scope.showAddAnotherSponsorBtn = true;
        }
      });
    }
  }
  needAnotherSponsorBtn($scope.leg);
  $scope.onExpand = function () {
    $scope.showSponsor();
  };
  $scope.addAnotherSponsor = function (index) {
    var clonedLeg = _.cloneDeep($scope.leg);
    clonedLeg.flightSponsor = undefined;
    $scope.scheduleChange.managedEntities.splice(index + 1, 0, clonedLeg);
    $scope.showAddAnotherSponsorBtn = false;
    $scope.leg.flightSponsor = $scope.sponsor;
  };
};
ReviewSponsorFlightPanelController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = ReviewSponsorFlightPanelController;